let lenisInstance = null;

export const setLenis = (l) => {
  lenisInstance = l;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) lenisInstance.scrollTo(el, { offset: -88, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const scrollTop = () => {
  if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
};

export const PREFILL_EVENT = "xmove:prefill";
const PREFILL_KEY = "xmove-prefill-auto";

export const prefillAuto = (label) => {
  try {
    sessionStorage.setItem(PREFILL_KEY, label);
  } catch {}
  window.dispatchEvent(new CustomEvent(PREFILL_EVENT, { detail: label }));
};

// Legge (e consuma) un prefill salvato prima di un cambio pagina
export const consumePrefill = () => {
  try {
    const v = sessionStorage.getItem(PREFILL_KEY);
    if (v) sessionStorage.removeItem(PREFILL_KEY);
    return v;
  } catch {
    return null;
  }
};

// Salva il prefill SENZA notificare i form di questa pagina (per navigazioni cross-pagina)
export const stashPrefill = (label) => {
  try {
    sessionStorage.setItem(PREFILL_KEY, label);
  } catch {}
};
